import { useLocation, useNavigate } from 'react-router-dom';
import DashboardIcon from '../../../../assets/images/svg/DashboardIcon';
import { useAuth } from '../../../../context/AuthProvider';
import { BuildNumber } from '../../../layout/components/BuildNumber';
import { Logo } from '../../topNav';
import ProfileIcon from '../../topNav/components/ProfileIcon';

type SettingsMenuProps = {
  onClose: () => void;
};

function SettingsMenu({ onClose }: SettingsMenuProps): JSX.Element {
  const { handleLogout, authCommunity, isAdministrator, authUser } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();
  const handleShowProfileBuilder = () => {
    onClose();

    if (location.pathname === '/admin/settings/profile') {
      return;
    }

    navigate({
      pathname: '/admin/settings/profile',
    });
  };

  const handleOnLogout = () => {
    onClose();
    handleLogout();
  };
  return (
    <div className='relative z-50 flex h-full w-auto flex-col items-center justify-between'>
      {isAdministrator ? (
        <div className='flex w-full flex-row items-center justify-start space-x-2 border-b border-b-gray-light bg-gray-lightest px-6 py-3'>
          <Logo />
        </div>
      ) : (
        <div className='flex w-full flex-row items-center justify-start space-x-3 border-b border-b-gray-light bg-gray-lightest px-4 py-3'>
          <div className='flex-shrink-0'>
            <ProfileIcon
              imgSrc={authCommunity?.logo}
              width='w-6'
              height='w-6'
            />
          </div>
          <span className='break-words text-sm font-semibold tracking-tighter text-gray'>
            {authUser?.fullName}
          </span>
        </div>
      )}

      <ul className='relative z-50 flex w-full flex-col'>
        {!isAdministrator ? (
          <li>
            <button
              className='group flex w-full flex-row items-center px-9 py-3 text-left text-sm font-semibold tracking-tight text-gray hover:bg-gray-lightest focus:outline-none'
              onClick={handleShowProfileBuilder}
            >
              <div className='mr-5.5 h-2 w-2 rounded-full bg-gray group-hover:bg-green'></div>
              Settings
            </button>
          </li>
        ) : null}
        <li>
          <button
            className='group flex w-full flex-row items-center px-8 py-3 text-left text-sm font-semibold tracking-tight text-gray hover:bg-gray-lightest focus:outline-none'
            onClick={handleOnLogout}
          >
            <div className='mr-4 text-gray group-hover:text-green'>
              <DashboardIcon
                className='stroke-current'
                width='18'
                height='18'
                strokeWidth='2'
              />
            </div>
            Logout
          </button>
        </li>
      </ul>
      <BuildNumber />
    </div>
  );
}

export default SettingsMenu;
